module.exports = __webpack_public_path__ + "assets/img/8_1234_big.74dd3a84.jpg";